import { useIssApi } from "@bfc-software/bfc-web-ui/lib/iss-api-client";

import type { QueryLike } from "@bfc-software/bfc-web-ui/lib/async-utils";

/** One customer as the filter offers it. `id` is `CustomerRec.id` (the wire's
 *  `customer_ext_id`) as an opaque string; `toWireExtIds` makes it a number at
 *  the wire. */
export interface CustomerOption {
  id: string;
  label: string;
}

/** ISS's own clamp on `limit`; the same one `customers.tsx` pages with. */
const FETCH_LIMIT = 500;

/**
 * The customer filter's option list: the item service's customer recs for this
 * warehouse, read once on page load and treated as a constant.
 *
 * One unpaged call of 500, the way `user-groups.tsx` reads it. A warehouse with
 * more customers than that is truncated silently.
 */
export function useCustomerCatalog(): QueryLike<CustomerOption[]> {
  const client = useIssApi();

  return client.useQuery(
    "get",
    "/customer-recs/list",
    { params: { query: { limit: FETCH_LIMIT, offset: 0 } } },
    {
      select: (envelope) =>
        envelope.data
          .map((customer) => ({
            id: String(customer.id),
            label: customer.name,
          }))
          .sort((a, b) => a.label.localeCompare(b.label)),
    },
  );
}
